import { graphql } from '../../gql';

/**
 * What a row of the catalogue needs to say: what it is, what it costs, and
 * whether it is a physical thing. Price comes off the variants because that is
 * where it lives — a single-variant product still has one.
 */
export const PRODUCT_LIST_INFO_FRAGMENT = graphql(`
  fragment ProductListInfo on ProductInfo {
    title
    productType
    images {
      id
      isFeatured
      image {
        thumbnailUrl
      }
    }
    variants {
      id
      price
    }
  }
`);

export const PRODUCTS_QUERY = graphql(`
  query Products(
    $filter: String
    $first: Int
    $after: String
    $before: String
    $productStatus: [ProductStatus!]
    $reviewStatus: [ProductReviewStatus!]
    $productType: ProductType
    $priceMin: Float
    $priceMax: Float
    $createdAfter: Date
    $createdBefore: Date
  ) {
    productConnection(
      filter: $filter
      first: $first
      after: $after
      before: $before
      productStatus: $productStatus
      reviewStatus: $reviewStatus
      productType: $productType
      priceMin: $priceMin
      priceMax: $priceMax
      createdAfter: $createdAfter
      createdBefore: $createdBefore
    ) {
      count
      edges {
        node {
          id
          idAlias
          status
          reviewStatus
          updatedAt
          current {
            ...ProductListInfo
          }
          pending {
            ...ProductListInfo
          }
          __typename
        }
        __typename
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
  }
`);

/**
 * Counts for the command header. Separate from the list query on purpose: they
 * describe the whole catalogue and must not move when the list is filtered —
 * the counts say what exists, the list says what matches.
 */
export const PRODUCT_STATUS_COUNTS_QUERY = graphql(`
  query ProductStatusCounts {
    productStatusCounts {
      active
      draft
      archived
      new
      awaitingReview
      changesRequested
      total
    }
  }
`);
